import Vue from 'vue';
import Vuex from 'vuex';
import profile from '@/store/profile';
import registration from '@/store/registration';
import contact  from '@/store/contact';
import jobs from '@/store/jobs';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    profile,
    registration,
    contact,
    jobs
  },
});
